module.exports = __webpack_public_path__ + "img/history_detail_9.a6d46a12.png";